export default {
  payment: '充值',
  order: '訂單',
  paymentMethod: '付款方式',
  choosePaymentMethod: '選擇付款方式',
  moreOptions: '更多充值方式',
  bank: '銀行',
  name: '名字',
  enterCardOwnerName: '輸入您付款卡的持卡人姓名',
  phoneNumber: '手機號碼',
  enterYourCardPhoneNumber: '輸入您付款卡對應的手機號',
  lowest: '最低',
  highest: '最高',
  rmb: '元',
  point: '積分',
  enterCustomAmount: '輸入自定義金額',
  payAmount: '付款金額',
  cardNumber: '卡號',
  enterCardNumber: '請輸入付款卡卡號',
  payImmediately: '立即支付',
  have: '有',
  personSuccess: '的人成功充值',
  channelUnavailable: '暫無可用通道',
  paymentType: '支付類型',
  orderUnavailable: '訂單不存在',
  error: '錯誤',
  requestAgain: '訂單已存在，請重新發起',
  orderNumber: '訂單號',
  enterCardOwner: '請輸入付款銀行卡姓名',
  enterRealName: '請輸入您的真實姓名',
  enterPhone: '請輸入您的手機號',
  enterAnInteger: '請輸入整數',
  paymentSupport: '充值支持',
  requestTooFrequently: '訂單發起過於頻繁',
  needToSlowlyRequest: '對不起，因您頻繁發起訂單但未提交支付',
  waitFiveMinutes: '請您休息五分鐘再嘗試，謝謝您的配合',
  done: '完成',
  chooseLanguage: '選擇語言',
  en: '英文',
  vn: '越南文',
  cn: '簡體中文',
  tw: '繁體中文',
  copy: '複製',
  tips: '溫馨提示',
  scanQrcode: '掃描 Qrcode 或點擊複製地址',
  screenshotAndScript: '查找單號請提供截圖以及附言碼',
  orderInfo: '訂單信息',
  address: '地址',
  scripts: '附言',
  qrcode: 'QR Code',
  ipBlock: '您已被封锁，请联系您的上层',
  invalidName: '未實名認證',
  paid: '支付成功',
  channelMaintain: '通道維護中，請聯繫客服',
  id_number: '身分證號',
  phone: '手機號',
  fixWrong: '請修改錯誤',
  formatWrong: '格式不正確',
  mobilePlaceholder: '填寫您的手機號碼 (e.g. 254123456789)',
  loading: '處理中...',
  recreateOrder: '當前通道不可用，請重新創建訂單',
  orderDetail: '訂單詳情',
  paymentWarning: '請務必依照下方顯示的收款資訊進行支付',
  alipayAccount: '支付寶帳號',
  alipaySurname: '支付寶姓氏',
  alipayName: '支付寶名稱',
  alipayRealName: '支付寶實名',
  paymentFlow: '支付流程',
  pleasePayWithin: '請於',
  minute: '分',
  second: '秒',
  countdownSuffix: '內完成支付，超過時間將無法到帳',
  orderExpired: '訂單已超時，無法到帳',
  warmReminder: '溫馨提醒',
  copied: '已複製',
  uploadProof: '上傳支付憑證',
  selectImage: '點擊選擇圖片',
  submitProof: '提交憑證',
  uploading: '上傳中...',
  uploadSuccess: '上傳成功',
  uploadFailed: '上傳失敗，請重試'
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-TW.js